import { render, staticRenderFns } from "./SubjectFormModal.vue?vue&type=template&id=34c902ce&"
import script from "./SubjectFormModal.vue?vue&type=script&lang=js&"
export * from "./SubjectFormModal.vue?vue&type=script&lang=js&"
import style0 from "./SubjectFormModal.vue?vue&type=style&index=0&id=34c902ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports